import React from 'react';
import styled from 'styled-components';
import { useIVAChatStatus, useIVASetChatStatus } from '../../../IVAChatStatusProvider';
import IconButton from '../../AlmeUtilities/Icons/IconButton';
import SwithPositionIcon from '../../../assets/images/switch-position-icon.svg';
const ArrowRightLeftContainer = styled.div `
    display: inline-block;
    margin-right: 15px;
`;
export const SwitchChatPositionButton = (props) => {
    const { chatPosition } = useIVAChatStatus();
    const { positionChat } = useIVASetChatStatus();
    const chatPositionPrefix = chatPosition.indexOf("Top") === 0 ? "Top" : "Bottom";
    const chatPositionSuffix = chatPosition.replace(chatPositionPrefix, "");
    let chatPostionFunc = chatPositionPrefix.toLowerCase() + "Right";
    let label = "Move window right";
    if (chatPositionSuffix === "Right") {
        label = "Move window left";
        chatPostionFunc = chatPositionPrefix.toLowerCase() + "Left";
    }
    return (React.createElement(ArrowRightLeftContainer, null,
        React.createElement(IconButton, Object.assign({ id: 'alme-position-left-right', "aria-label": label, title: label, icon: React.createElement("img", { src: SwithPositionIcon, alt: "Switch chat position icon", "aria-hidden": true }), type: "button", size: 20, onClick: positionChat[chatPostionFunc] }, props.focusProps))));
};
